import React from 'react';
import { Button } from './ui/button';
import { ArrowUpRight, FileDown, Footprints, Mountain, Route } from 'lucide-react';

export const HalfMarathonPage = () => {
  const eventDetailsRows = [
    { label: 'Date', value: 'Sunday 26th July 2026' },
    { label: 'Distance', value: '21.1km' },
    { label: 'Entry fee', value: <a href="#event-details" className="text-foreground underline decoration-primary/60 underline-offset-2 hover:decoration-primary">View Entry fees here</a> },
    { label: 'Start Time', value: '6:45 am' },
    { label: 'Start Line', value: 'Camden Start Precinct (Access the start line from the race precinct via Market Street)' },
    { label: 'Finish Line', value: 'Camden Finish Precinct' },
    { label: 'Minimum age', value: 'Must be at least 13 years old to enter' },
    { label: 'Bib Collection', value: 'We recommend you collect your bib prior to race day. If you would prefer, you can also have your race bib delivered straight to your door - just be sure to select postage 2 weeks before race day so it arrives in time. See dates and times for pick up here.' },
    { label: 'Prizes', value: 'All half marathon finishers will receive a Run Camden Finisher Medal. Prize money will be awarded to 1st, 2nd and 3rd Male and Female across the finish line.' },
  ];

  return (
    <>
      <section className="section-full pt-24 sm:pt-28 md:pt-32">
        <div className="container-wide">
          <div className="grid lg:grid-cols-2 overflow-hidden border border-border">
            <div className="bg-primary text-foreground p-8 sm:p-12 lg:p-14">
              <p className="text-xs uppercase tracking-widest font-black mb-3">Run Camden</p>
              <h1 className="display-title text-5xl sm:text-6xl lg:text-7xl mb-3">
                Half Marathon - 21.1km
              </h1>
              <p className="text-sm sm:text-base uppercase tracking-widest font-black mb-4">
                Sunday 26th July 2026
              </p>
              <p className="text-lg sm:text-xl font-semibold mb-4">
                Time To Hit Your Next PB!
              </p>
              <p className="text-base sm:text-lg mb-8 max-w-xl">
                The 21.1km course showcases Camden at its best and is designed for committed runners aiming for a strong race-day result.
              </p>
              <Button
                asChild
                className="bg-white text-foreground px-8 py-4 font-black uppercase tracking-wider rounded-full shadow-lg hover:bg-white/90"
              >
                <a href="#event-details">Register for 21.1km</a>
              </Button>
            </div>
            <div className="relative min-h-[320px] sm:min-h-[420px] lg:min-h-[520px]">
              <img
                src="/race-half-marathon.webp"
                alt="Half Marathon runners"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section-full bg-muted py-8 sm:py-10 lg:py-12 border-t border-border">
        <div className="container-wide">
          <div className="grid md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="bg-white border border-border p-5 sm:p-6">
              <Route className="text-primary mb-3" size={28} />
              <p className="text-xs uppercase tracking-widest font-bold text-muted-foreground mb-1">Distance</p>
              <p className="text-2xl font-black" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>21.1km</p>
            </div>
            <div className="bg-white border border-border p-5 sm:p-6">
              <Mountain className="text-primary mb-3" size={28} />
              <p className="text-xs uppercase tracking-widest font-bold text-muted-foreground mb-1">Elevation Gain</p>
              <p className="text-2xl font-black" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>135m</p>
            </div>
            <div className="bg-white border border-border p-5 sm:p-6">
              <Footprints className="text-primary mb-3" size={28} />
              <p className="text-xs uppercase tracking-widest font-bold text-muted-foreground mb-1">Terrain</p>
              <p className="text-2xl font-black" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>99% pavement / footpath</p>
            </div>
          </div>

          <div id="event-details" className="bg-white border border-border p-6 sm:p-8 mb-10 sm:mb-12">
            <div className="grid xl:grid-cols-2 gap-8 items-start">
              <div>
                <h2 className="text-3xl sm:text-4xl font-black mb-5" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  EVENT DETAILS
                </h2>
                <div className="overflow-x-auto border border-border">
                  <table className="w-full min-w-[620px]">
                    <tbody>
                      {eventDetailsRows.map((row) => (
                        <tr key={row.label} className="border-t border-border first:border-t-0">
                          <th className="w-44 px-4 py-3 text-left text-xs uppercase tracking-widest font-black bg-foreground text-white align-top">
                            {row.label}
                          </th>
                          <td className="px-4 py-3 text-sm text-muted-foreground align-top bg-white">
                            {row.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 mt-7">
                  <Button asChild className="btn-standard group w-full sm:w-auto">
                    <a href="https://ridewithgps.com/routes/53850045" target="_blank" rel="noreferrer">
                      Open Course Map
                      <ArrowUpRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                    </a>
                  </Button>
                  <Button asChild className="btn-standard-outline group w-full sm:w-auto">
                    <a href="/Run_Camden_21.1km_FINAL.gpx" target="_blank" rel="noreferrer">
                      Download GPX
                      <FileDown className="ml-2 group-hover:translate-y-0.5 transition-transform" size={18} />
                    </a>
                  </Button>
                </div>
              </div>

              <iframe
                title="Half Marathon Course Map"
                src="https://ridewithgps.com/embeds?type=route&id=53850045&metricUnits=true&sampleGraph=true&hideSurface=true"
                style={{ width: '1px', minWidth: '100%', height: '700px', border: 'none' }}
                scrolling="no"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HalfMarathonPage;
